import { Button } from '@material-ui/core';
import styled from 'styled-components';
import colors from '../../styles/settings/colors';

export const TableTitleHeader = styled.div`
  align-items: center;
  background-color: ${colors.sanMarino};
  color: #fff;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 0 0 4px;
  overflow: hidden !important;
  border-top-right-radius: 11px;
  border-top-left-radius: 11px;
`;

export const LoaderContainer = styled.div`
  align-items: center;
  flex: 1;
  display: flex;
  flex-flow: column;
  justify-content: center;
  height: 100vh;
`;

export const Container = styled.div`
  font-family: 'Segoe UI';
  max-width: 980px;
  margin: 0 auto;

  .message-html {
    font-family: 'Segoe UI';
    font-size: small;
  }
`;

export const Header = styled.header`
  text-align: center;
  img {
    height: auto;
    padding: 8px;
    width: auto;
    max-width: 100%;
    max-height: 120px;
  }

  h1 {
    font-family: 'Segoe UI';
  }
`;

export const InfoContainer = styled.div`
  border: solid 1px #000;
  border-radius: 15px;
  margin-top: 10px;
  h1 {
    font-family: 'Segoe UI';
    text-align: center;
    font-weight: bold;
    margin: 0 auto;
    padding: 2px 4px;
  }
`

export const ConfirmationBox = styled.div`
  max-width: 400px;
  margin: 16px 0;
  width: 100%;

  button {
    margin: 8px 0;
    width: calc(100% - 22px);

    &.Mui-disabled {
      background-color: rgb(35 45 100 / 90%) !important;
      cursor: not-allowed !important;
    }
  }
`;

export const ActionButton = styled(Button)`
  background-color: ${colors.sanMarino}!important;
  color: ${colors.white}!important;
  font-size: 13px !important;
  min-width: 200px !important;
`;

export const ResponseMessage = styled.div`
  display: block;
  font-size: 1.2rem;
  font-weight: bold;
  margin: 38px;
  text-align: center;
`;
